import {
  UserDomainWithWebsiteInterface,
  WebsiteId,
  WebsiteInterface,
} from '../types/website-interface'
import { formUrl } from 'shared/utils/links/form-url'

export const getUrlWebsiteEdit = (id: WebsiteId) => {
  return formUrl(`/websites/page/${id}/edit`)
}

export const getUrlWebsiteView = (
  website: WebsiteInterface,
  userDomainsWithWebsite?: UserDomainWithWebsiteInterface[],
) => {
  if (website.active) {
    const domainName = userDomainsWithWebsite?.find(el => el.id === website.domainId)?.name

    return `${process.env.NEXT_PUBLIC_SIO_HOST_SCHEME}://${domainName}/${website.homePagePath}`
  }
  else {
    // return `${getUrlWebsiteEdit(website.id)}?preview=true`
    return ``

  }
}
